import React, { Component } from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import { ThemeProvider } from '@mui/material/styles';
// import CssBaseline from "@material-ui/core/CssBaseline";
import theme from "./theme";
import "./App.css";
import Navbar from "./components/Navbar";
import Landing from "./pages/Landing";
import TokenPurchase from "./pages/TokenPurchase";
import PageNotFound from "./pages/PageNotFound";

function App() {
  const htmlStyle = {
    // overflowX: "hidden",
  };

  return (
    <ThemeProvider theme={theme}>
      {/* <CssBaseline /> */}
      <div style={htmlStyle}>
        <Router>
          <Navbar />
          <Switch>
            <Route exact path="/" component={Landing} />
            <Route exact path="/tokens-exchange" component={TokenPurchase} />
            <Route path="*" component={PageNotFound} />
          </Switch>
        </Router>
      </div>
    </ThemeProvider>
  );
}

export default App;
